module.exports = __webpack_public_path__ + "static/img/u165.4b8d4f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u165.png
// module id = 8h9e
// module chunks = 0